import { Node } from "@xyflow/react";
import { useAtomValue } from "jotai";
import { Button, Icon } from "@zapier/design-system";
import {
  nodeAtomFamily,
  DefaultNodeData,
  assetTypeAndLinkAtomFamily,
} from "@zapier/canvas-state";

import { useEmitUserInteractionEvents } from "../../../hooks/useEmitUserInteractionEvents";

type Props = {
  nodeId: string;
};

export function EditAssetButton({ nodeId }: Props) {
  const node = useAtomValue(nodeAtomFamily(nodeId)) as Node<DefaultNodeData>;
  const { emitEventOnAssetOpen } = useEmitUserInteractionEvents();
  const { assetType, assetLink } = useAtomValue(
    assetTypeAndLinkAtomFamily(nodeId!),
  );

  return (
    <>
      {assetType === "table" && node.data.tableId && (
        <Button
          variant="primary"
          iconPosition="start"
          onPress={() => {
            window.open(assetLink, "_blank");
            emitEventOnAssetOpen({
              asset: "table",
              location: "sidebar",
            });
          }}
        >
          <Icon name="arrowOffsite" />
          Edit Table
        </Button>
      )}
      {assetType === "interface" && node.data.projectId && (
        <Button
          variant="primary"
          iconPosition="start"
          onPress={() => {
            window.open(assetLink, "_blank");
            emitEventOnAssetOpen({
              asset: "interface",
              location: "sidebar",
            });
          }}
        >
          <Icon name="arrowOffsite" />
          Edit Interface
        </Button>
      )}
      {assetType === "chatbot" && node.data.chatbotId && (
        <Button
          variant="primary"
          iconPosition="start"
          onPress={() => {
            window.open(assetLink, "_blank");
            emitEventOnAssetOpen({
              asset: "chatbot",
              location: "sidebar",
            });
          }}
        >
          <Icon name="arrowOffsite" />
          Edit Chatbot
        </Button>
      )}
      {assetType === "agent" && node.data.agentId && (
        <Button
          variant="primary"
          iconPosition="start"
          onPress={() => {
            window.open(assetLink, "_blank");
            emitEventOnAssetOpen({
              asset: "agent",
              location: "sidebar",
            });
          }}
        >
          <Icon name="arrowOffsite" />
          Edit Agent
        </Button>
      )}
    </>
  );
}
